import React from 'react'
import TableLayout from '../../components/TableLayout'

const ProductTypesListContainer = () => {


    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Descripción',
            dataIndex: 'description',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Categoría',
            dataIndex: 'category.name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de tipo de productos"
                columns={columns}
                resource="subcategories"
                actions={['excel','active', 'create', 'edit', 'show']}
            />
        </>
    )
}

export default ProductTypesListContainer
